import React, { useState, useEffect, useRef } from 'react';
import { ROLE_VAR } from '../../data/frameworks.registry';

// Threat Vector framework selector (prototype .fw / .fw-btn / .fw-menu): a mono
// pill showing the active framework with a role-coloured dot, opening a menu of
// role-coloured options. Registry-driven (ADR-2) — reports a frameworkId.
const FrameworkSelector = ({ frameworks, selectedFrameworkId, selectedLabel, onFrameworkChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  const activeRole = frameworks.find((f) => f.id === selectedFrameworkId)?.semanticRole || 'defence';

  return (
    <div className="tv-fw" ref={ref}>
      <button type="button" className="tv-fw-btn" onClick={() => setOpen((v) => !v)}>
        <span className="tv-left">
          <span className="tv-dot" style={{ background: ROLE_VAR[activeRole] }} />
          {selectedLabel}
        </span>
        <span style={{ color: 'var(--tv-muted)' }}>▾</span>
      </button>
      {open && (
        <div className="tv-fw-menu">
          {frameworks.map((f) => (
            <button
              type="button"
              key={f.id}
              className={`tv-fw-opt ${f.id === selectedFrameworkId ? 'active' : ''}`}
              onClick={() => {
                onFrameworkChange(f.id);
                setOpen(false);
              }}
            >
              <span className="tv-dot" style={{ background: ROLE_VAR[f.semanticRole] }} />
              {f.label}
              <span className="tv-role" style={{ color: ROLE_VAR[f.semanticRole] }}>
                {f.semanticRole}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FrameworkSelector;
